
import React, { Fragment } from 'react';

//Components

import SummaryItem from '../SummaryItem';



const MilitaryInfo = props => {

    const {
        idx,
        honorablyDischargedOrActiveDutyMilitaryMemberIndicator
    } = props;

    if(honorablyDischargedOrActiveDutyMilitaryMemberIndicator === null) {
        return null;
    }

    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.are_you_veteran_or_active_military'
                value = { honorablyDischargedOrActiveDutyMilitaryMemberIndicator }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].citizenshipImmigrationStatus.honorablyDischargedOrActiveDutyMilitaryMemberIndicator`
                        ]
                    ]
                }
            />
        </Fragment>
    );
};

export default MilitaryInfo;